var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showHeader)?_c('header-bar',{attrs:{"showMenu":"","showLogo":""}}):_vm._e(),_c('h2',{staticClass:"message"},[_c('i',{staticClass:"material-icons"},[_vm._v(_vm._s(_vm.icon))]),_c('span',[_vm._v(_vm._s(_vm.message))])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }